export default function alphaBlendColors(
  foregroundRgba: [number, number, number, number],
  backgroundRgb: [number, number, number],
): [number, number, number] {
  const alpha = foregroundRgba[3];
  return [
    Math.round(foregroundRgba[0] * alpha + backgroundRgb[0] * (1 - alpha)),
    Math.round(foregroundRgba[1] * alpha + backgroundRgb[1] * (1 - alpha)),
    Math.round(foregroundRgba[2] * alpha + backgroundRgb[2] * (1 - alpha)),
  ];
}
